import PropTypes from 'prop-types'
import React from 'react'
import profilePic from '../images/profile-pic.png'
import Image from './images'

const Menu = ({ timeout, menuBar, menuBarClick, onOpenArticle, delay }) => (

	<div id="menu" style={timeout || delay ? { display: 'none' } : {}}>
		<nav>
			<div className={`menu-branding ${menuBar ? 'show' : ''}`}>
				<Image imageName="profile-pic.png" className="profile-pic" alt="profile-pic" />
				<ul className="icons">
					<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
						<a
							target="_blank" rel="noreferrer"
							href="https://twitter.com/LeonilOmayan93?s=09"
							className="icon fab fa-twitter"
						>
							<span className="label">Twitter</span>
						</a>
					</li>
					<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
						<a
							target="_blank" rel="noreferrer"
							href="https://facebook.com/leonil.omayan"
							className="icon fab fa-facebook-f">
							<span className="label">Facebook</span>
						</a>
					</li>
					<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
						<a
							target="_blank" rel="noreferrer"
							href="https://instagram.com/leo_nil_"
							className="icon fab fa-instagram">
							<span className="label">Instagram</span>
						</a>
					</li>
					<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
						<a
							target="_blank" rel="noreferrer"
							href="https://github.com/Leonil1993"
							className="icon fab fa-github"
						>
							<span className="label">GitHub</span>
						</a>
					</li>
					<span className="menu-brand-item-spam">
						<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
							<a
								href="tel:+639059538246"
								className="icon fas fa-phone"
							>
								<span className="label">Phone Number</span>
							</a>
						</li>
						{/*<li className={`menu-brand-item ${menuBar ? 'show' : '' }`}>
				    <a
				      target="_blank" rel="noreferrer"
				      href="https://www.google.com.ph/maps/@7.1032078,125.4992702,18z"
				      className="icon fab fa-map"
				    >
				      <span className="label">Map</span>
				    </a>
				  </li>*/}
						<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
							<a
								href="mailto:leonil.omayan.lo@gmail.com"
								className="icon far fa-envelope"
							>
								<span className="label">Map</span>
							</a>
						</li>
					</span>
				</ul>
				<div className="menu-brand-banner">
					<h3 className={`menu-brand-heading ${menuBar ? 'show' : ''}`}>Hello there!</h3>
					<h4 className={`menu-brand-heading ${menuBar ? 'show' : ''}`}>
						I'm <span className="full-name">Leonil Omayan,</span>
						a Web Developer Proficient in HTML5, CSS3, JAVASCRIPT ES5/ES6 and PHP.
					</h4>
					<h4 className={`menu-brand-heading ${menuBar ? 'show' : ''}`}>
						Get in touch |
						<a href="mailto://leonil.omayan.lo@gmail.com">leonil.omayan.lo@gmail.com </a>
					</h4>
				</div>
			</div>

			<ul className={`menu-nav ${menuBar ? 'show' : ''}`}>
				<li className={`menu-nav-item ${menuBar ? 'show' : ''}`}>
					<button
						onClick={() => {
							onOpenArticle('about');
						}}
					>
						About
					</button>
				</li>
				<li className={`menu-nav-item ${menuBar ? 'show' : ''}`}>
					<button
						onClick={() => {
							onOpenArticle('skills');
						}}
					>
						Skills
					</button>
				</li>
				<li className={`menu-nav-item ${menuBar ? 'show' : ''}`}>
					<button
						onClick={() => {
							onOpenArticle('project');
						}}
					>
						Projects
					</button>
				</li>

				<li className={`menu-nav-item ${menuBar ? 'show' : ''}`}>
					<button
						onClick={() => {
							onOpenArticle('contact');
						}}
					>
						Contact
					</button>
				</li>

			</ul>
		</nav>
	</div>
);

Menu.propTypes = {
	onOpenArticle: PropTypes.func,
	menuBarClick: PropTypes.func,
	timeout: PropTypes.bool,
	delay: PropTypes.bool,
	menuBar: PropTypes.bool
}

export default Menu